import React from 'react';
import { set, get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { checkCurrency, shortenStringWithTooltip, roundOff, roundingOff } from '../../../../../Components/helper';
import AverageCostingExpandView from './ExpandView/AverageCostingExpandView';
import useShowHideSectionHooks from '../Hooks/useShowHideSectionHooks';

export function AverageCostingTable({ productInfoObj }) {
  const { t } = useTranslation('common');
  const { productCostingstate, setProductCostingState } = productInfoObj;
  const {
    averageCosting: { averageCostingInfo, overAllSumOfQuantityPerSizCol, overAllSumOfTotalPrice, totLength, totSize, totColourways },
    productInfo: { currency },
    isBreakdown,
  } = productCostingstate;

  const { hideLengthCol } = useShowHideSectionHooks(productInfoObj);
  const renderComponent = Array.isArray(averageCostingInfo) && averageCostingInfo?.length > 0;

  const expandAverageCostingChild = (index) => {
    const copyState = productCostingstate;
    const path = `averageCosting.averageCostingInfo[${index}].isExpanded`;
    const expanded = get(copyState, path, false);
    set(copyState, path, !expanded);
    setProductCostingState((state) => ({ ...state, ...copyState }));
  };

  return (
    renderComponent && (
      <div className="table-responsive average-colourway-table">
        <table className="table common-custom-table ">
          <thead>
            <tr>
              <th className="w-50px" />
              <th className="w-200px">{t('COSTING_TO_DO_LIST.COLORWAY')}</th>
              <th className="w-200px">{isBreakdown ? 'Size Range' : 'Size'}</th>
              {hideLengthCol && <th className="w-200px">{isBreakdown ? 'Length Range' : 'Length'}</th>}
              <th className="w-250px">{t('COSTING_TO_DO_LIST.QUANTITY')}</th>
              <th className="w-250px">{t('COSTING_TO_DO_LIST.PRICE_PER_UNIT')}</th>
              <th className="w-200px">{t('FILTER.TOTAL_PRICE')}</th>
            </tr>
          </thead>

          <tbody>
            {averageCostingInfo?.map((data, index) => {
              return !data?.isExpanded && data?.expandData.length !== 1 && !isBreakdown ? (
                <tr key={index}>
                  <td>
                    {data?.expandData &&
                      data?.expandData.length > 0 &&
                      (data?.isExpanded ? (
                        <button
                          className="btn-up-down"
                          type="button"
                          aria-label={t('COMMON_LABEL.OPEN')}
                          onClick={() => {
                            expandAverageCostingChild(index);
                          }}
                        >
                          <span className="icon-new-down-arrow-icon icon-inverse" />
                        </button>
                      ) : (
                        <button
                          className="btn-up-down"
                          type="button"
                          aria-label={t('COMMON_LABEL.CLOSE')}
                          onClick={() => {
                            expandAverageCostingChild(index);
                          }}
                        >
                          <span className="icon-new-down-arrow-icon" />
                        </button>
                      ))}
                  </td>
                  <td>{data?.colourway?.name}</td>
                  <td>{data?.isExpanded ? '--' : Array.isArray(totSize) && shortenStringWithTooltip(totSize?.join(', '), 15)}</td>
                  {hideLengthCol && <td>{data?.isExpanded ? '--' : Array.isArray(totLength) && shortenStringWithTooltip(totLength?.join(', '), 25)}</td>}
                  <td className="text-left">{roundOff(data?.sumOfQuantityPerSizCol, 4, true)}</td>
                  <td className="text-left">--</td>
                  <td className="text-left">
                    {checkCurrency(currency, data?.sumTotalPrice)} {roundingOff(data?.sumTotalPrice, 4, true)}
                  </td>
                </tr>
              ) : (
                (data?.isExpanded || data?.expandData?.length === 1 || isBreakdown) && (
                  <AverageCostingExpandView
                    expandData={isBreakdown ? [data?.expandData[0]] : data?.expandData}
                    index={index}
                    expandAverageCostingChild={expandAverageCostingChild}
                    isExpanded={data?.isExpanded}
                    colourway={data?.colourway}
                    sizeRange={data?.sizeRange}
                    lengthRange={data?.lengthRange}
                    productInfoObj={productInfoObj}
                  />
                )
              );
            })}
            <tr>
              <td />
              <td>
                <b>{totColourways?.length > 1 ? `${totColourways.length} Colourway(s)` : `${totColourways.length || 0} Colourway`}</b>
              </td>
              <td>
                <b>{totSize?.length > 1 ? `${totSize.length} Size(s)` : `${totSize.length || 0} Size`}</b>
              </td>
              {hideLengthCol && (
                <td>
                  <b>{totLength?.length > 1 ? `${totLength.length} Length(s)` : `${totLength.length || 0} Length`}</b>
                </td>
              )}
              <td className="text-left">
                <b>{`${roundOff(overAllSumOfQuantityPerSizCol, 4, true)} Units`}</b>
              </td>
              <td className="text-left">--</td>
              <td className="text-left">
                <b>
                  {checkCurrency(currency, overAllSumOfTotalPrice)} {roundingOff(overAllSumOfTotalPrice, 4, true)}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  );
}

export default AverageCostingTable;
